export default __webpack_public_path__ + "static/media/placeholder_portfolio02-nl-mobile.86655f30.png";